import { ArticleCard } from './ArticleCard';
import styles from './ArticleList.module.scss';
import type { Article } from '@/types/article';

interface ArticleListProps {
  articles: Article[];
  showAuthor?: boolean;
  emptyMessage?: string;
}

export function ArticleList({ articles, showAuthor = false, emptyMessage = 'No articles found' }: ArticleListProps) {
  if (articles.length === 0) {
    return (
      <div className={styles.articleList__empty}>
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={styles.articleList}>
      {articles.map((article, index) => (
        <ArticleCard
          key={article.id}
          article={article}
          index={index}
          showAuthor={showAuthor}
        />
      ))}
    </div>
  );
}
